module.exports = __webpack_public_path__ + "static/media/14.f9fc6faf.png";